"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProduct = exports.updateProducts = exports.addProduct = exports.getProduct = exports.getProducts = void 0;
const _ = require("lodash");
const getProducts = async (supabase) => {
    const { data, error } = await supabase
        .from("products")
        .select(`*`)
        .order("name", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getProducts = getProducts;
const getProduct = async (supabase, id) => {
    const { data, error } = await supabase
        .from("products")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getProduct = getProduct;
const addProduct = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase.from("products").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addProduct = addProduct;
const updateProducts = async (supabase, obj) => {
    const { data, error } = await supabase.from("products").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProducts = updateProducts;
const updateProduct = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id)
        updateObj.modified_by = user?.id;
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("products")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateProduct = updateProduct;
